var SupportChatSuccessView, SupportTicketSuccessView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportTicketSuccessView = require('./ticket_success_view');

SupportChatSuccessView = (function(superClass) {
  extend(SupportChatSuccessView, superClass);

  function SupportChatSuccessView() {
    return SupportChatSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportChatSuccessView.prototype.toHash = function() {
    var hash;
    hash = {
      showDefaultThankYouMsg: false,
      showChatThankYouMsg: true,
      showNeedHelpLink: true,
      showFooter: false,
      greeting_text: this.getGreetingText(),
      isChatFlow: true
    };
    return hash;
  };

  SupportChatSuccessView.prototype.getGreetingText = function() {
    return I18n.translate('js.modules.support.v2.thanks_chat');
  };

  return SupportChatSuccessView;

})(SupportTicketSuccessView);

module.exports = SupportChatSuccessView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY2hhdF9zdWNjZXNzX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY2hhdF9zdWNjZXNzX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsZ0RBQUE7RUFBQTs7O0FBQUEsd0JBQUEsR0FBMkIsT0FBQSxDQUFRLHVCQUFSOztBQUVyQjs7Ozs7OzttQ0FFSixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxzQkFBQSxFQUF3QixLQUF4QjtNQUNBLG1CQUFBLEVBQXNCLElBRHRCO01BRUEsZ0JBQUEsRUFBa0IsSUFGbEI7TUFHQSxVQUFBLEVBQVksS0FIWjtNQUlBLGFBQUEsRUFBZSxJQUFDLENBQUEsZUFBRCxDQUFBLENBSmY7TUFLQSxVQUFBLEVBQVksSUFMWjs7V0FNRjtFQVJNOzttQ0FVUixlQUFBLEdBQWlCLFNBQUE7V0FDZixJQUFJLENBQUMsU0FBTCxDQUFlLG1DQUFmO0VBRGU7Ozs7R0Faa0I7O0FBZXJDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
